import { useState, useEffect, useCallback } from 'react';
import { CurrencyLookupItem } from '../types/costwand';
import { apiClient, ApiError } from '../api/apiClient.ts';

interface UseCurrencyLookupResult {
  currencies: CurrencyLookupItem[];
  loading: boolean;
  error: string | null;
  fetchCurrencies: () => Promise<void>;
}

export const useCurrencyLookup = (): UseCurrencyLookupResult => {
  const [currencies, setCurrencies] = useState<CurrencyLookupItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCurrencies = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Changed to use allPages: true and expect { data: T[] }
      const response = await apiClient<{ data: CurrencyLookupItem[] }>('/currencies', { allPages: true });
      setCurrencies(response.data);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(`Failed to fetch currencies: ${err.message}`);
      } else {
        setError('An unknown error occurred while fetching currencies.');
      }
      setCurrencies([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCurrencies();
  }, [fetchCurrencies]);

  return {
    currencies,
    loading,
    error,
    fetchCurrencies,
  };
};